import efClient from './FrontEndClient';
import axios from "axios";
import {ListEventsForUserOptions} from "../../../Interfaces/efData";

const eventListOptions: EventListOptions = {
    attributesExcludeFilter: ['archived'],
    attributesFilter: ['event-app-enabled'],
    sortBy: 'event-start',
    sortDirection: 'ascending',
};

function listEvents(user_id: string, options:ListEventsForUserOptions): Promise<{}> {
    return efClient()
        .useCaseFactory.Event()
        .ListEventsForUser(
            user_id,
            options.query,
            eventListOptions.attributesFilter,
            eventListOptions.attributesExcludeFilter,
            ['Pool', 'Tags', 'ThumbnailUrl'],
            undefined,
            options.page,
            options.resultsPerPage,
            options.sortBy,
            options.sortDirection,
            eventListOptions.eventDateFilterType,
            undefined,
            eventListOptions.tags,
            undefined,
            true,
            true,
        );
}

function getEvent(event_id: string): Promise<{}> {
    return efClient()
        .useCaseFactory.Event()
        .GetEvent(
            event_id,
            ['Pool', 'Tags', 'PoolFeatures'],
        );
}

function fetchInviteeCountsForEvent(event_id: string): Promise<{}> {
    return efClient()
        .useCaseFactory.Invitation()
        .GetInvitationCountsForEvent(
            event_id,
        );
}

function fetchInviteesBatchForEvent(event_id: string, page: number, itemsPerPage: number): Promise<{}> {
    return efClient()
        .useCaseFactory.Invitation()
        .ListInvitationsForEvent(
            event_id,
            ['QuestionResponses'],
            ['info'],
            undefined,
            ['assigned', 'confirmed-by-rsvp', 'left-behind', 'purchased', 'registered', 'unconfirmed'],
            undefined,
            undefined,
            undefined,
            undefined,
            page,
            itemsPerPage,
        );
}

function fetchSitePages(eventId: string, page: number, itemsPerPage:number): Promise<{}> {
    return efClient()
        .useCaseFactory.SitePage()
        .ListSitePagesForEvent(eventId, page, itemsPerPage);
}

function listGroups(client_Id: string): Promise<{}> {
    return efClient()
        .useCaseFactory.Group()
        .ListGroupsOwnedByUser(client_Id);
}

export function listUsersInGroup(groupId: string, poolId: string, page: number, itemsPerPage: number): Promise<{}> {
    return efClient()
        .useCaseFactory.User()
        .ListUsersInGroup(groupId, poolId, ['UserNames'], undefined, undefined, undefined, page, itemsPerPage);
}

function logout(email: string): Promise<{}> {
    return efClient()
        .useCaseFactory.OAuth2()
        .RevokeAccessToken(email);
}
function getUser(client_id: string): Promise<{}> {
    return efClient()
        .useCaseFactory.User()
        .GetUser(client_id);
}

function getMe(): Promise<{}> {
    return axios.get("/me")
}

function getUserByEmail(email: string): Promise<{}> {
    return efClient()
        .useCaseFactory.User()
        .GetUserByEmail(email);
}

export interface EventListOptions {
    userId?: string;
    query?: string;
    attributesFilter?: any[];
    attributesExcludeFilter?: any[];
    withData?: any;
    lastModifiedTimestamp?: any;
    page?: any;
    itemsPerPage?: any;
    sortBy?: string;
    sortDirection?: string;
    eventDateFilterType?: any;
    teamId?: string;
    tags?: any;
}
export interface Pagination {
    currentEventsPage: number;
    resultsPerPage: number;
    currentTicketBlocksPage: number;
}

export default {
    fetchInviteesBatchForEvent,
    fetchSitePages,
    getUser,
    getMe,
    getUserByEmail,
    listEvents,
    listGroups,
    listUsersInGroup,
    logout,
    getEvent,
    fetchInviteeCountsForEvent
};
